import {
    getManualTransactionUpdateBlocker,
    isManuallyCreatedTransactionType,
    MANUAL_TRANSACTION_LOCKED_MESSAGE,
    ManualTransactionUpdateEligibilityInput,
} from "@common/helpers/manual-transaction-update";
import {
    InvoiceOrBillMatchFields,
    isMatchedToInvoiceOrBill,
} from "@common/helpers/transactions";
import { AccrualMatchDisplay } from "@common/schemas/domains/accrualReview/accrual-review.schema";
import { Transaction } from "@common/types/transaction";

export type ManualTransactionUpdateSource = Transaction & {
    accrualMatches?: AccrualMatchDisplay[];
};

type ManualTransactionUpdateAvailabilityInput = Omit<
    ManualTransactionUpdateEligibilityInput,
    "isMatchedToInvoiceOrBill"
> & {
    transactionMatches?: InvoiceOrBillMatchFields[] | null;
    accrualMatches?: InvoiceOrBillMatchFields[] | null;
};

interface ManualTransactionUpdateAvailability {
    isManualTransaction: boolean;
    disabledReason: string | null;
}

export function getManualTransactionUpdateAvailability({
    transaction,
    isLocked,
}: {
    transaction: ManualTransactionUpdateAvailabilityInput;
    isLocked: boolean;
}): ManualTransactionUpdateAvailability {
    const blocker = getManualTransactionUpdateBlocker({
        type: transaction.type,
        reconciledInId: transaction.reconciledInId,
        splitParentId: transaction.splitParentId,
        pairedTransferId: transaction.pairedTransferId,
        schedule: transaction.schedule,
        isMatchedToInvoiceOrBill: isMatchedToInvoiceOrBill(
            transaction.transactionMatches,
            transaction.accrualMatches,
        ),
    });

    return {
        isManualTransaction: isManuallyCreatedTransactionType(transaction.type),
        disabledReason: isLocked ? MANUAL_TRANSACTION_LOCKED_MESSAGE : blocker,
    };
}
